import { Button, Group, Modal, Textarea } from '@mantine/core';
import React, { useState } from 'react';

import { IncidentType, useResolveIncident } from '@portals/api/organizations';
import { ModalBody, ModalFooter } from '@portals/core';
import { ModalProps } from '@portals/framework';
import { ReactComponent as TicketCircle } from '@portals/icons/linear/tick-circle.svg';

export interface ResolveIncidentModalProps
  extends ModalProps<{
    incident: IncidentType;
    onSuccess?: () => void;
  }> {}

export function ResolveIncidentModal({
  data,
  closeMe,
}: ResolveIncidentModalProps) {
  const { incident, onSuccess } = data;
  const resolveIncident = useResolveIncident();

  const [reason, setReason] = useState('');

  const handleSubmit = () => {
    resolveIncident.mutate(
      {
        incident: incident,
        resolve_reason: reason,
      },
      {
        onSuccess: () => {
          onSuccess?.();

          closeMe();
        },
      }
    );
  };

  return (
    <Modal
      opened
      onClose={closeMe}
      padding="xxl"
      title={
        <Group>
          <TicketCircle />
          Resolve incident?
        </Group>
      }
    >
      <ModalBody>
        <Textarea
          placeholder="Add details..."
          data-testid="resolve-incident-textarea"
          maxRows={7}
          minRows={7}
          error={resolveIncident.isError}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </ModalBody>

      <ModalFooter grow>
        <Button variant="default" onClick={closeMe}>
          Cancel
        </Button>

        <Button
          loading={resolveIncident.isLoading}
          data-testid="resolve-incident-modal-close-button"
          onClick={handleSubmit}
        >
          Resolve Incident
        </Button>
      </ModalFooter>
    </Modal>
  );
}
